import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Typography, Grid, Button } from "@mui/material";
import { getCoupon, getDeleteCoupon } from "redux/actions/UserCouponAction";
import CommonForm from "components/commonForm/CommonForm";
import { couponFormData } from "./CouponFormData";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import Loader from "components/loader/Loader";
import useModal from "components/hooks/useModel";
import CommonDialog from "components/commonDialog/CommonDialog";
import { handlePermissions } from "utils/utils";
import { roleAndPermissionEnum } from "utils/rolesPermissionsEnum";
import deleteicon from "assets/images/delete.svg";
import subscriptionService from "services/SubscriptionService";

function CouponDetails() {
  const { state } = useLocation() || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { open: openConfirm, toggle: setOpenConfirm } = useModal();
  const couponDetails = useSelector(
    (state) => state?.userCoupon?.userCoupon?.data?.body
  );
  const loader = useSelector((state) => state?.userCoupon?.loading);
  const locationData = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );
  const dutyTypeOptions = useSelector(
    (state) => state?.userChooseYourService?.userChooseYourService?.data
  );
  const id = {
    couponId: state?.couponId,
  };

  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [plansLoaded, setPlansLoaded] = useState(false);

  useEffect(() => {
    dispatch(getCoupon(id));
    subscriptionService.getSubscriptionList().then(res => {
      setSubscriptionPlans(res?.data?.body || []);
      setPlansLoaded(true);
    }).catch(() => setPlansLoaded(true));
  }, []);

  const onClickOpen = () => {
    setOpenConfirm(true);
  };

  const redirect = () => {
    setOpenConfirm(false);
    navigate('/promotions');
  };

  const onDelete = () => {
    const val = {
      couponID: {
        id: state?.couponId,
      },
      redirect: redirect,
      key: "couponDetails"
    };
    dispatch(getDeleteCoupon(val));
  };



  const breadcrumbPaths = [
    { name: "Configuration", url: "/promotions", className: "colorBlue" },
    { name: "Coupon Details", url: "", className: "colorBlue" },
  ];

const defaultValues = {
  ...couponDetails,
  perventageValue: couponDetails?.discountValue,
  isNewUser: couponDetails?.isNewUser ? "isNewUser" : "existingUser",
  discountType:
  couponDetails?.type === "Flat Discount"
  ? "Flat"
  : couponDetails?.type === "Percentage Discount"
  ? "Percentage"
  : couponDetails?.type,
  category: couponDetails?.category,
  subscriptionPlanId: couponDetails?.subscriptionPlanId,
  referralType: couponDetails?.referralType === "referee" || couponDetails?.referralType === "referrer"
      ? couponDetails?.referralType
      : "referee", // fallback to referee if undefined
};

  //roles and permissions
  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions
  );
  const configRoleEnum = roleAndPermissionEnum.configuration;

  const accessForall = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { defaultAllAccess: configRoleEnum?.subModules?.coupon?.all }
  );

  const accessForEdit = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { customAccess: configRoleEnum?.subModules?.coupon?.edit }
  );

  const accessForDelete = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { customAccess: configRoleEnum?.subModules?.coupon?.delete }
  );

  const addAccess = (accessForall || accessForDelete);
  return (
    <div>
      <CommonBreadCrumb paths={breadcrumbPaths} />
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="marginBlock10 paddingInline40"
      >
        <Grid item>
          <Typography className="colorBlue fw600 font20">
            Coupon {state?.couponCode} Details
          </Typography>
        </Grid>
        <Grid item>
          {addAccess && <Button className="dflex font16" onClick={onClickOpen}>
            <img src={deleteicon} alt="deleteicon" className="mr10" />
            <Typography className="textCapitalize colorBlack font16">
              Delete
            </Typography>
          </Button>}
        </Grid>
      </Grid>
      {(loader || !plansLoaded) ? (
        <Loader />
      ) : (
        <div className="paddingInline40 paddingBottom20">
          <CommonForm
            key={`${couponDetails?.id}-${subscriptionPlans.length}`}
            formData={couponFormData("details", locationData, dutyTypeOptions, null, null, subscriptionPlans)}
            defaultValues={defaultValues}
            disabled ={true}
            formName="couponDetailsForm"
            selectType="details"
          />
        </div>
      )}

      {openConfirm ? (
        <CommonDialog
          open={openConfirm}
          handleClose={() => setOpenConfirm(false)}
          toggle={setOpenConfirm}
          onConfirmDialog={onDelete}
          text={"Are you sure to delete this coupon?"}
          selectType={"delete"}
          dialogContent={"couponDelete"}
        />
      ) : null}
    </div>
  );
}

export default CouponDetails;
